import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/finance")({
  beforeLoad: ({ location }) => {
    if (location.pathname === "/finance") throw redirect({ to: "/finance/dashboard" });
  },
  component: () => (
    <RouteGuard module="finance"><Outlet /></RouteGuard>
  ),
});
